module.exports = __webpack_public_path__ + "static/media/navijet.f509f173.png";